/* jshint ignore:start */
'use strict';

/**
 *  Create and add dimmer element
 */
function addDimmer(sitedimmed) {
	if (!sitedimmed) {
		sitedimmed = true;
	}

	// Check if element already exists
	if (document.querySelector('.selma-dimmer')) {
		return false;
	}

	var dimmer = document.createElement('div');

	dimmer.className = 'selma-dimmer';
	if (sitedimmed) {
		document.body.classList.add('site-dimmed');
		setTimeout(function () {
			dimmer.classList.add('dim-active');
		}, 100);
	}
	document.body.appendChild(dimmer);
}

/**
 *  Remove dimmer element
 */
function removeDimmer(sitedimmed) {
	if (!sitedimmed) {
		sitedimmed = true;
	}

	var dimmer = document.querySelector('.selma-dimmer');
	// Only remove if it exists
	if (dimmer) {
		dimmer.classList.remove('dim-active');
		if (sitedimmed) {
			document.body.removeChild(dimmer);
			document.body.classList.remove('site-dimmed');
		}
		// setTimeout(function() {
		//     console.log(sitedimmed);
		//     if (sitedimmed) {
		//         document.body.removeChild(dimmer);
		//         document.body.classList.remove('site-dimmed');
		//     }
		// }, 300);
	}
}

(function (window, document, $) {
	// Go down to
	if ($('.go-down-to').length > 0) {
		$('.go-down-to').click(function () {
			var target = $(this).attr('data-element');
			$('html, body').animate({
				scrollTop: $('.' + target).offset().top - 100
			}, 500);
		});
	}

	// Search
	var searchTrigger = $('.fn-search');
	var searchElem = $('.fn-search-field');

	searchTrigger.click(function (event) {
		addDimmer();

		function clear() {
			removeDimmer();

			$('.fn-search-field').removeClass('search-active');
			$('#searchQuery').val('');
		}

		if (searchElem.hasClass('search-active')) {
			$('.fn-search-field').removeClass('search-active');
		}

		setTimeout(function () {
			$('.fn-search-field').addClass('search-active');
		}, 300);

		$('.fn-close-search').click(function () {
			clear();
		});

		$(document).click(function (event) {
			if (!$(event.target).closest(searchElem).length && $('body').hasClass('site-dimmed')) {
				clear();
			}
		});

		$(document).keyup(function (e) {
			if ($('body').hasClass('site-dimmed')) {
				if (e.keyCode === 27) {
					clear();
				}
			}
		});

		event.stopPropagation();
	}); // Search end


	// Restaurant menus
	var $menuBtn = $('.fn-menu-button');
	$menuBtn.click(function () {
		var type = $(this).attr('data-meny-type');

		$('.fn-menu-elem').hide();

		$('body').addClass('site-dimmed');
		$('.fn-menu-elem[data-meny-type="' + type + '"]').show();
		$('.selma-meny-wrapper').addClass('active');

		function clear() {
			$('body').removeClass('site-dimmed');
			$('.selma-meny-wrapper').removeClass('active');
			$('.fn-menu-elem').hide();
		}

		$('.close-meny').click(function () {
			clear();
		});

		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				clear();
			}
		});
	});

	// Book Modal
	var $bookBtn = $('.fn-book-modal');
	$bookBtn.click(function (e) {
		e.preventDefault();

		if ($('.selma-booking-modal').hasClass('active')) {
			clear();
			return false;
		}

		$('.fn-book-open').removeClass('lnr-chevron-down').addClass('lnr-chevron-up');
		$('.selma-booking-modal').addClass('active');
		$('.header').addClass('pop-out');
		addDimmer();

		function clear() {
			removeDimmer();
			$('.fn-book-open').removeClass('lnr-chevron-up').addClass('lnr-chevron-down');
			$('.selma-booking-modal').removeClass('active');
			$('.header').removeClass('pop-out');
		}

		$(document).click(function (e) {
			if ($('.selma-dimmer.dim-active').is(e.target)) {
				clear();
			}
		});

		$('.fn-close-booking').click(function () {
			clear();
		});

		$(document).keyup(function (e) {
			if (e.keyCode === 27) {
				clear();
			}
		});
	});

	// Newsletter Arrow
	// if ($('.footer__section--newsletter .mc4wp-form-fields :submit').length > 0) {
	//     $('<span class="lnr lnr-chevron-right fn-submit-newsletter"></span>').insertBefore($('.footer__section--newsletter .mc4wp-form-fields :submit'));

	//     $('.fn-submit-newsletter').click(function() {
	//         $('#mc4wp-form-1').submit();
	//     });
	// }

	// Block link
	if ($('.block-listing__block').length > 0) {
		$('.block-listing__block').not('.promo-block').click(function (e) {
			if ($(this).attr('data-link')) {
				window.location.href = $(this).attr('data-link');
			}
		});
	}
	// Big Block link
	if ($('.big-blocks__block').length > 0) {
		$('.big-blocks__block').click(function (e) {
			if ($(this).attr('data-link')) {
				window.location.href = $(this).attr('data-link');
			}
		});
	}

	// Social Block link
	if ($('.selma-social__feed--image').length > 0) {
		$('.selma-social__feed--image').click(function (e) {
			if ($(this).attr('data-link')) {
				window.location.href = $(this).attr('data-link');
			}
		});
	}

	// SEO Block
	if ($('.seo-block').length > 0) {
		var contentText = $('.seo-block-content').html();
		var shortText = $('.seo-block-content').text().substring(0, 300) + '...';
		$('.seo-block-content').html(shortText);

		$('.fn-show-seo-text').click(function (e) {
			e.preventDefault();
			$('.seo-block-content').html(contentText);
			$(this).hide();
		});
	}

	// filter blogg items
	if ($('.filter-list-item').length > 0) {

		//fix size of filter-list since it is rotated:
		$('.filter-list').height($('.filter-container').width());
		$(window).on('resize', function () {
			$('.filter-list').height($('.filter-container').width());
		});

		$('.rotation-wrapper').each(function () {
			$(this).height($(this).width());
			$(this).width(55);
		});

		$('.filter-list-item').click(function () {
			OnFilterClick(this);
		});

		function OnFilterClick(element) {
			if (!$(element).hasClass('filter-list-item-active')) {
				$('.filter-list-item').each(function () {
					$(this).removeClass('filter-list-item-active');
				});
				$(element).addClass('filter-list-item-active');
				TogglePosts(',' + $(element).attr("data-slug") + ',');
			}
		}

		function TogglePosts(category) {
			$('.post-featured').addClass('post-item');
			$('.post-featured').removeClass('post-featured');
			var hasFeatured = false;
			$('.post-item').each(function () {
				$(this).hide();
				var postCats = ',' + $(this).attr('data-filter') + ',';
				if (category == ',alla,' || postCats.includes(category)) {
					if (!hasFeatured) {
						$(this).addClass('post-featured');
						$(this).removeClass('post-item');
						$(this).fadeIn();
						$(this).css('display', 'block');
						hasFeatured = true;
					}
					else {
						$(this).fadeIn();
						$(this).css('display', 'inline-block')
					}
				}
			});
		}

		// init Isotope
		if ($('.block-grid-blocks').length > 0) {
			console.log('tes')
			var $grid = $('.block-grid-blocks').isotope({
				itemSelector: '.block',
				layoutMode: 'fitRows'
			});
		}

		// bind filter button click
		$('.block-filter li').on('click', function () {
			var filterValue = $(this).attr('data-filter');

			$grid.isotope({ filter: filterValue });

			$('.block-filter li').removeClass('active');
			$(this).addClass('active');
		});
	}


})(window, document, jQuery);
